import { Button } from "@heroui/react"
import { useEffect, useState } from "react"
import { EmailInput } from "../inputs/EmailInput"
import { isEmailValid } from "../validate"
import { motion } from "framer-motion"

const EmailStep = ({ email, setEmail, setCurrentStep, setResetPassword }) => {
    const [isFormValid, setIsFormValid] = useState(false)
    const [isEmailSending, setIsEmailSending] = useState(false)
    const PRESENTATION_MODE = process.env.REACT_APP_PRESENTATION_MODE === 'true'
    const [serverError, setServerError] = useState("")

    const sendResetEmail = async () => {
        if (PRESENTATION_MODE) {
            setServerError("Sorry, aome stopped its activity. Bye bye")
            return
        }

        setIsEmailSending(true)
        try {
            await fetch(`${process.env.REACT_APP_API_BASE}/auth/send-password-reset-email`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                })
            })
            // setCurrentStep("success")

        } catch (error) {

        } finally {
            setCurrentStep("success")
            setIsEmailSending(false)
        }
    }

    useEffect(() => {
        setIsFormValid(isEmailValid(email))
    }, [email])

    return (
        <motion.div
            className="w-full min-h-[400px] lg:h-[650px] lg:w-[500px] flex flex-col justify-center items-center gap-5 px-5 py-10 lg:py-20 lg:px-10"
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
        >
            <div className="flex flex-col w-full gap-2 items-center justify-center">
                <p className="text-xl font-light text-white">パスワード再設定</p>
                <span className="font-light w-full text-white text-center text-sm"> 登録したメールアドレスを入力してください。再設定用のメールをお送りします。</span>
            </div>


            <div className="w-full flex flex-col items-center justify-center gap-3">
                <EmailInput email={email} setEmail={setEmail} />
            </div>

            <div className="flex justify-center items-center gap-3 w-full">

                <Button
                    variant="light"
                    className="font-light w-max text-white"
                    startContent={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-move-left-icon lucide-move-left text-white"><path d="M6 8L2 12L6 16" /><path d="M2 12H22" /></svg>}
                    onPress={() => setResetPassword(false)}
                >
                    戻る
                </Button>

                <Button
                    className="bg-[#27485C] font-light w-full text-white"
                    isDisabled={!isFormValid}
                    isLoading={isEmailSending}
                    onPress={sendResetEmail}
                >
                    パスワード再設定メールを送信
                </Button>
            </div>

            {serverError &&
                <div className="w-full flex flex-col items-center justify-center">
                    <span className="flex items-start gap-2 text-danger text-tiny w-max max-w-full rounded-md bg-danger-50 py-1 px-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-x-icon lucide-circle-x text-danger"><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg>
                        {serverError}
                    </span>
                </div>
            }

        </motion.div>
    )
}

const SuccessMessage = ({ setCurrentStep }) => {

    return (
        <motion.div
            className="w-full min-h-[400px] lg:h-[650px] lg:w-[500px] flex flex-col justify-center items-center gap-5 px-5 py-10 lg:py-20 lg:px-10"
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
        >
            <div className="flex flex-col w-full gap-2 items-center justify-center">
                <p className="text-xl font-light text-white">送信が完了しました</p>
                <span className="font-light w-full text-white text-center text-sm">登録したメールアドレスにメールを送信しました。記載された手順に従ってください。</span>
            </div>

            <div className="flex justify-center items-center gap-3 w-full">

                <Button
                    variant="light"
                    className="font-light w-max text-white"
                    startContent={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-move-left-icon lucide-move-left text-white"><path d="M6 8L2 12L6 16" /><path d="M2 12H22" /></svg>}
                    onPress={() => setCurrentStep("email")}
                >
                    戻る
                </Button>
            </div>

        </motion.div>
    )
}


export const ResetPassword = ({ setResetPassword }) => {

    const [email, setEmail] = useState("")
    const [currentStep, setCurrentStep] = useState("email")

    return (
        currentStep === "email" ? <EmailStep email={email} setEmail={setEmail} setCurrentStep={setCurrentStep} setResetPassword={setResetPassword} />
            :
            currentStep === "success" && <SuccessMessage setCurrentStep={setCurrentStep} />
    )
}